import { NgModule } from '@angular/core';
import { LyExpansionIcon } from './expansion-icon';

@NgModule({
  declarations: [LyExpansionIcon],
  exports: [LyExpansionIcon]
})
export class LyExpansionIconModule { }
